module.exports = __webpack_public_path__ + "img/banner_czyy.23640b77.png";